var Marionette = require('backbone.marionette');

var Radio = require('backbone.radio');
var notificationsChannel = Radio.channel('notifications');

var CommonUtils = require('../../utils/common-utils.js');

var SvnInfoModal = Marionette.View.extend({
    template: require('../../templates/system/svn-info-modal.html'),

    ui: {
        modal: '#svn-info-modal',
        contentUI: '#svn-info-content-ui',
        contentAPI: '#svn-info-content-api',
        loader: '#svn-info-loader'
    },

    events: {},

    templateContext: function () {
        return {}
    },

    initialize: function (options) {
        var that = this;
        that.utils = new CommonUtils();
    },

    onRender: function () {
        var that = this;
        that.show();
        that.utils.showSpinner(that.ui.loader.id);

        $.ajax({
            type: "GET",
            url: '/api/system/info/svn',
            statusCode: {
                200: function (response) {
                    that.utils.hideSpinner(that.ui.loader.id);
                    that.renderTable(that.ui.contentAPI, response);
                }
            },
            error: function (e) {
                that.utils.hideSpinner(that.ui.loader.id);
                notificationsChannel.request('show:notification', e.responseJSON);
                that.utils.hideSpinner(that.ui.loader.id);
            }
        });

        var onlyNeedEntries = {};

        _.keys(__SVN_INFO__).filter(function (key) {
            return key === "lastChangedAuthor"
                || key === "lastChangedDate"
                || key === "lastChangedRev"
                || key === "repositoryUuid"
                || key === "url"
        }).forEach(function (key) {
            var value = __SVN_INFO__[key];
            switch (key) {
                case 'lastChangedAuthor':
                    onlyNeedEntries["Last Changed Author"] = value;
                    break;
                case 'lastChangedDate':
                    onlyNeedEntries["Last Changed Date"] = value;
                    break;
                case 'lastChangedRev':
                    onlyNeedEntries["Last Changed Rev"] = value;
                    break;
                case 'repositoryUuid':
                    onlyNeedEntries["Repository UUID"] = value;
                    break;
                case 'url':
                    onlyNeedEntries["URL"] = value;
                    break;
                default:
                    onlyNeedEntries[key] = value;
                    break;
            }
        });

        that.renderTable(that.ui.contentUI, onlyNeedEntries);
    },

    renderTable: function (target, data) {

        var tableStart = "<table class='table table-bordered table-hover'><tr><th class='center'>Key</th><th class='center'>Value</th></tr>";
        var tableEnd = "</table>";

        var sortedByKey = _.sortBy(_.keys(data) || [], function (key) {
            return key;
        });
        sortedByKey = sortedByKey.reverse();
        var tableBody = sortedByKey.map(function (key) {
            return '<tr><td>' + key + '</td><td>' + data[key] + '</td></tr>';
        }).join("")

        target.html(tableStart + tableBody + tableEnd);
    },

    show: function () {
        this.ui.modal.modal({backdrop: 'static', keyboard: false});
    },

    hide: function () {
        this.ui.modal.modal('hide');
    }
});

module.exports = SvnInfoModal;


//////////////////
// WEBPACK FOOTER
// ./app/views/system/svn-info-modal.js
// module id = 530
// module chunks = 0